import { createContext } from 'react';
/** Provider 밖(preview 등)에서 쓰는 안전한 기본값. */
export const MEDIA_UNLOCK_FALLBACK = {
    phase: 'unlocked',
    unlocked: true,
    showStrap: false,
    requestUnlock: () => {
        // no-op
    },
};
export const MediaUnlockContext = createContext(null);
//# sourceMappingURL=mediaUnlockContextValue.js.map